import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisterUserComponent } from './register-user.component';
import { BasicModalModule } from '../../shared/modules/modals/basic-modal/basic-modal.module';
import { ButtonModule } from '../../shared/modules/button/button.module';

@NgModule({declarations: [RegisterUserComponent],
  imports: [
    CommonModule,
    BasicModalModule,
    ButtonModule,
  ],
exports: [RegisterUserComponent]})
export class RegisterUserModule { }
